import React from 'react';

import { ReactComponent as Parliament } from '../assets/icons/primary-button-ui-prime-minister-icon.svg';

import { ReactComponent as Arrow } from '../assets/icons/primary-button-ui-arrow-icon.svg';
import { ReactComponent as Settings } from '../assets/icons/essential-button-ui-settings-icon.svg';

import { ReactComponent as Exit } from '../assets/icons/settings-button-ui-exit-icon.svg';
import { ReactComponent as Info } from '../assets/icons/settings-button-ui-information-icon.svg';
import { ReactComponent as AudioOn } from '../assets/icons/settings-button-ui-sound-on-icon.svg';
import { ReactComponent as AudioOff } from '../assets/icons/settings-button-ui-sound-off-icon.svg';
import { ReactComponent as Play } from '../assets/icons/primary-button-ui-play-icon.svg';

import { ReactComponent as Tick } from '../assets/icons/tick-icon.svg';
import { ReactComponent as Cross } from '../assets/icons/cross-icon.svg';
import { ReactComponent as Plus } from '../assets/icons/primary-button-ui-plus-icon.svg';
import { ReactComponent as Edit } from '../assets/icons/edit-icon.svg';

import { ReactComponent as Local } from '../assets/icons/primary-button-ui-local-icon.svg';
import { ReactComponent as Global } from '../assets/icons/primary-button-ui-global-icon.svg';
import { ReactComponent as Financial } from '../assets/icons/primary-button-ui-financial-icon.svg';

import { ReactComponent as StartOfDay } from '../assets/icons/start-of-day-image.svg';

import { ReactComponent as DetailedMeetings } from '../assets/icons/detailed/detailed-icon-meetings.svg';
import { ReactComponent as DetailedDebate } from '../assets/icons/detailed/detailed-icon-debate.svg';
import { ReactComponent as DetailedInquiry } from '../assets/icons/detailed/detailed-icon-inquiry.svg';
import { ReactComponent as DetailedQuestions } from '../assets/icons/detailed/detailed-icon-questions.svg';
import { ReactComponent as DetailedPress } from '../assets/icons/detailed/detailed-icon-press.svg';
import { ReactComponent as DetailedMessages } from '../assets/icons/detailed/detailed-icon-messages.svg';
import { ReactComponent as DetailedVote } from '../assets/icons/detailed/detailed-icon-vote.svg';

import { ReactComponent as Messages } from '../assets/icons/primary-button-ui-message-icon.svg';
import { ReactComponent as Press } from '../assets/icons/primary-button-ui-press-icon.svg';
import { ReactComponent as Meetings } from '../assets/icons/primary-button-ui-meetings-icon.svg';
import { ReactComponent as Debate } from '../assets/icons/primary-button-ui-debate-icon.svg';
import { ReactComponent as Inquiry } from '../assets/icons/primary-button-ui-inquiry-icon.svg';
import { ReactComponent as Questions } from '../assets/icons/primary-button-ui-questions-icon.svg';
import { ReactComponent as Vote } from '../assets/icons/primary-button-ui-vote-icon.svg';
import { ReactComponent as Locked } from '../assets/icons/primary-button-ui-locked-icon.svg';

import { ReactComponent as Sender } from '../assets/icons/person-icon-white.svg';
import { ReactComponent as Meeting } from '../assets/icons/primary-button-ui-gather-icon.svg';

import { ReactComponent as Phone } from '../assets/icons/incoming-call-phone-icon.svg';
import { ReactComponent as Caller1 } from '../assets/icons/phone-call/person-01.svg';
import { ReactComponent as Caller2 } from '../assets/icons/phone-call/person-02.svg';
import { ReactComponent as Caller3 } from '../assets/icons/phone-call/person-03.svg';

import { ReactComponent as Clock } from '../assets/icons/time-passing-no-hands.svg';

import wit00 from '../assets/icons/committee/icon_wit_00.png';
import wit01 from '../assets/icons/committee/icon_wit_01.png';
import wit02 from '../assets/icons/committee/icon_wit_02.png';
import wit03 from '../assets/icons/committee/icon_wit_03.png';
import wit04 from '../assets/icons/committee/icon_wit_04.png';
import wit05 from '../assets/icons/committee/icon_wit_05.png';
import wit06 from '../assets/icons/committee/icon_wit_06.png';
import wit07 from '../assets/icons/committee/icon_wit_07.png';
import wit08 from '../assets/icons/committee/icon_wit_08.png';

import wit10 from '../assets/icons/committee/icon_wit_10.png';
import wit11 from '../assets/icons/committee/icon_wit_11.png';
import wit12 from '../assets/icons/committee/icon_wit_12.png';
import wit13 from '../assets/icons/committee/icon_wit_13.png';
import wit14 from '../assets/icons/committee/icon_wit_14.png';
import wit15 from '../assets/icons/committee/icon_wit_15.png';
import wit16 from '../assets/icons/committee/icon_wit_16.png';
import wit17 from '../assets/icons/committee/icon_wit_17.png';
import wit18 from '../assets/icons/committee/icon_wit_18.png';
import wit19 from '../assets/icons/committee/icon_wit_19.png';
import wit20 from '../assets/icons/committee/icon_wit_20.png';
import wit21 from '../assets/icons/committee/icon_wit_21.png';
import wit22 from '../assets/icons/committee/icon_wit_22.png';
import wit23 from '../assets/icons/committee/icon_wit_23.png';
import wit24 from '../assets/icons/committee/icon_wit_24.png';

import Climate from '../assets/icons/press/game-press-symbol-polar.png';
import Crime from '../assets/icons/press/game-press-symbol-justice.png';
import Employment from '../assets/icons/press/game-press-symbol-employment.png';
import Arts from '../assets/icons/press/game-press-symbol-culture.png';
import WorldIssues from '../assets/icons/press/game-press-symbol-global.png';
import Education from '../assets/icons/press/game-press-symbol-education.png';
import Sports from '../assets/icons/press/game-press-symbol-sports.png';

const icons = {
    parliament: <Parliament />,

    arrow: <Arrow />,

    settings: <Settings />,

    exit: <Exit />,
    info: <Info />,
    'audio-on': <AudioOn />,
    'audio-off': <AudioOff />,
    play: <Play />,

    tick: <Tick />,
    cross: <Cross />,
    plus: <Plus />,
    edit: <Edit />,

    local: <Local />,
    global: <Global />,
    financial: <Financial />,

    'start-of-day': <StartOfDay />,

    'detailed-meetings': <DetailedMeetings />,
    'detailed-messages': <DetailedMessages />,
    'detailed-press': <DetailedPress />,
    'detailed-debate': <DetailedDebate />,
    'detailed-inquiry': <DetailedInquiry />,
    'detailed-vote': <DetailedVote />,
    'detailed-questions': <DetailedQuestions />,

    messages: <Messages />,
    press: <Press />,
    meetings: <Meetings />,
    debate: <Debate />,
    inquiry: <Inquiry />,
    questions: <Questions />,
    vote: <Vote />,
    locked: <Locked />,

    sender: <Sender />,
    attendee: <Meeting />,

    phone: <Phone />,
    'caller-1': <Caller1 />,
    'caller-2': <Caller2 />,
    'caller-3': <Caller3 />,
    'caller-4': <Caller3 />,

    clock: <Clock />,

    climate: Climate,
    crime: Crime,
    employment: Employment,
    arts: Arts,
    'world-issues': WorldIssues,
    education: Education,
    sports: Sports,
};

export const getIconFromName = iconName => {
    return icons[iconName];
};

const committeeIcons = {
    wit_00: wit00,
    wit_01: wit01,
    wit_02: wit02,
    wit_03: wit03,
    wit_04: wit04,
    wit_05: wit05,
    wit_06: wit06,
    wit_07: wit07,
    wit_08: wit08,
    wit_10: wit10,
    wit_11: wit11,
    wit_12: wit12,
    wit_13: wit13,
    wit_14: wit14,
    wit_15: wit15,
    wit_16: wit16,
    wit_17: wit17,
    wit_18: wit18,
    wit_19: wit19,
    wit_20: wit20,
    wit_21: wit21,
    wit_22: wit22,
    wit_23: wit23,
    wit_24: wit24,
};

export const getCommitteeIconFromID = index => {
    return committeeIcons[index];
};

export const allPngs = [
    wit00,
    wit01,
    wit02,
    wit03,
    wit04,
    wit05,
    wit06,
    wit07,
    wit08,
    wit10,
    wit11,
    wit12,
    wit13,
    wit14,
    wit15,
    wit16,
    wit17,
    wit18,
    wit19,
    wit20,
    wit21,
    wit22,
    wit23,
    wit24,
    Climate,
    Crime,
    Employment,
    Arts,
    WorldIssues,
    Education,
    Sports,
];
